export enum Colors {
  PRIMARY = "#fff0f3",
  SECONDARY = "#fb6f92",
  TEXTDARK = "#1b2021",
  TEXTLIGHT = "#FFFFFF",
}
